<div class="toggle-add-on-page-container container">
  <mtn-simple-panel color="purple">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <fa-icon icon="exclamation-triangle" size="2x"></fa-icon>
      <div>{{ 'ADD_ON.WARNING' | translate }}</div>
    </div>
  </mtn-simple-panel>
  <p>
    {{ 'ADD_ON.CONFIRMATION' | translate: { action: isEnabling ? ('ADD_ON.ENABLE' | translate) : ('ADD_ON.DISABLE' | translate),
    addOn: wizard.model.addOn.typeDefinition.displayName } }}
  </p>
</div>
